import { Box, Button, Td, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { OrganizationTypeTag } from "../../../../common/organization/OrganizationTypeTag";
import { urls } from "../../../../urls";
import { CombinedInvite } from "./InvitedOrganizations";

interface OrganizationCellProps {
  invite: CombinedInvite;
  rowSpan: number;
}

export const OrganizationCell = ({ invite, rowSpan }: OrganizationCellProps) => {
  const navigate = useNavigate();

  return (
    <Td rowSpan={rowSpan} verticalAlign="top">
      {invite.type === "Organization" && !!invite.organizationId ? (
        <Button
          variant={"link"}
          size="sm"
          colorScheme={"teal"}
          onClick={() => invite.organizationId && navigate(urls.organizations.profile.go(invite.organizationId))}
        >
          {invite.organizationName}
        </Button>
      ) : (
        <Text fontWeight="semibold">{invite.organizationName}</Text>
      )}
      <Box pt="2">
        <OrganizationTypeTag type={invite.type} />
      </Box>
    </Td>
  );
};
